<template>
  <div class="man_list">
    <div class="ava_img" v-for="(item,index) in manArr" :key="index">
      <div><img :src='item.avatar?item.avatar:(item.headimgurl?item.headimgurl:avatar.avatar)'/></div>
      <div class="ava_name">{{item.name?item.name:item.userName}}</div>
      <div v-if="item.time" class="ava_time">{{item.time}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        avatar: {
          avatar:require('../../../../public/img/default-avatar.png')
        },
      }
    },
    props:['manArr']
  }
</script>

<style lang="scss" scoped>
  .man_list {
    flex-wrap: wrap;
    display: flex;
    .ava_img {
      min-width: 80px;
      text-align: center;

      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }

      view:nth-of-type(1) {
        width: 32px;
        height: 32px;
        text-align: center;
        margin: auto;
      }
    }
    .ava_name {
      font-size: 12px;
      color: rgba(25, 31, 37, 0.8);
      min-width: 50px;
    }
    .ava_time{
      font-size: 12px;
      color: rgba(25, 31, 37, 0.8);
    }
  }
</style>
